<template>
    <div>
        <!--<a-pagination v-model:current="current" :total="50" show-less-items />-->

        <menu_c/>
        <div style="padding: 20px 30px">
            <Waterfall :list="list" :gutter="20" :width="300">
                <!-- 新版插槽数据获取 -->
                <template #default="{ item, url }">
                    <div class="card">
                        <LazyImg :url="url" @click="seeDetail(item)" />
                        <div class="text" style="padding: 5px" v-html="item.content" @click="seeDetail(item)"></div>
                    </div>
                </template>
            </Waterfall>
        </div>
        <foot_c/>
    </div>
</template>

<script setup>
    import foot_c from '../../components/foot_c.vue';
    import menu_c from '../../components/menu_c.vue';
    import {onMounted, ref} from 'vue';
    import {API_articlesListBySectionId} from '../../api/api.js'
    import { useRoute,useRouter } from 'vue-router'
    import { LazyImg, Waterfall } from 'vue-waterfall-plugin-next'
    import 'vue-waterfall-plugin-next/dist/style.css'


    const list =  ref([]);

    const route = useRoute()
    const router = useRouter();

    const current = ref(1);

    onMounted(() => {
        console.log("search",route.query)
        var aid = route.query.aid;
        getlist(aid,current.value,10);
    });

    // function openAboutPageInNewTab() {
    //     // 假设你的应用部署在根路径，如果是子路径则需要相应地调整
    //     const url = window.location.origin + '/about'; // 或者使用 router.resolve() 来获取完整的 URL
    //     // 使用 window.open 打开新标签页
    //     window.open(url, '_blank');
    // }

    function getlist(aid,current,pageSize) {
        API_articlesListBySectionId(aid, current,pageSize).then(res => {
            if (res.success && res.result.total) {
                list.value = res.result.list.map(item => {
                    return {
                        ...item,
                        src: process.env.VUE_APP_BASE_API + process.env.VUE_APP_GLOB_API_URL + `/sys/common/static/${item.pic}`
                    }
                });
            }

        });
    }

    function seeDetail(item) {
        router.push(item.link)
    }
</script>

<style scoped>
    /* For demo */
    :deep(.slick-slide) {
        text-align: center;
        max-height: 700px;
        /*line-height: 160px;*/
        /*background: darkcyan;*/
        overflow: hidden;
    }

    :deep(.slick-slide h3) {
        color: #fff;
    }

    :deep(.slick-slide img) {
        width: 100%;
        height: 100%;
        object-fit: cover; /* 类似于background-size: cover;的效果 */
    }

</style>